<template>


  <v-card>
    <!-- <v-card-title class="headline primary white--text mb-4">
            Akademik Raporlama Filtresi
          </v-card-title> -->
    <v-toolbar dark color="primary">

      <v-toolbar-title> Akademik Raporlama Filtresi</v-toolbar-title>
      <v-spacer></v-spacer>

    </v-toolbar>
    <v-card-text>
      <div class="text-subtitle-1 mb-2 font-weight-bold">Birim Türü:</div>
      <v-radio-group v-model="birimTur" row class="mt-0">
        <v-radio label="Personel Bilgi Sistemi" value="personel"></v-radio>
        <v-radio label="Personel Bilgi Sistemi İdari" value="personelidari"></v-radio>
        <v-radio label="Öğrenci Bilgi Sistemi" value="ogrenci"></v-radio>


      </v-radio-group>

      <div v-if="birimTur === 'personel' || birimTur === 'ogrenci'">
        <div class="text-subtitle-1 mb-2 font-weight-bold">Raporlama Düzeyi:</div>
        <v-radio-group v-model="hedefSeviye" row @change="resetForm" class="mt-0">
          <v-radio label="Fakülte Bazlı" value="fakulte"></v-radio>
          <v-radio label="Bölüm Bazlı" value="bolum"></v-radio>
          <v-radio label="Program Bazlı" value="program"></v-radio>
        </v-radio-group>

        <v-divider class="my-4"></v-divider>

        <v-row>
          <v-col cols="12">

            <v-select v-model="secilenFakulte" return-object :items="distinctFakulteler" item-text="fakulte_ad"
              item-value="fak_kod" :label="hedefSeviye === 'fakulte' ? 'Fakülteler (Çoklu Seçim)' : 'Fakülte Seçiniz'"
              :multiple="hedefSeviye === 'fakulte'" :chips="hedefSeviye === 'fakulte'"
              :deletable-chips="hedefSeviye === 'fakulte'" clearable outlined dense @change="fakulteChanged"
              placeholder="Fakülte listesinden seçiniz..."></v-select>
          </v-col>

          <v-col cols="12" v-if="hedefSeviye === 'bolum' || hedefSeviye === 'program'">
            <v-select v-model="secilenBolum" return-object :items="distinctBolumler" item-text="bolum_ad"
              item-value="bolum_id" :label="hedefSeviye === 'bolum' ? 'Bölümler (Çoklu Seçim)' : 'Bölüm Seçiniz'"
              :multiple="hedefSeviye === 'bolum'" :chips="hedefSeviye === 'bolum'"
              :deletable-chips="hedefSeviye === 'bolum'" :disabled="!secilenFakulte" clearable outlined dense
              @change="bolumChanged" placeholder="Önce fakülte seçiniz..."></v-select>
          </v-col>

          <v-col cols="12" v-if="hedefSeviye === 'program'">
            <v-select v-model="secilenProgram" return-object :items="distinctProgramlar" item-text="program_ad"
              item-value="program_id" label="Programlar (Çoklu Seçim)" multiple chips deletable-chips
              :disabled="!secilenBolum" clearable outlined dense placeholder="Önce bölüm seçiniz..."></v-select>
          </v-col>
        </v-row>
      </div>
<div v-else>
  
   <v-select v-model="secilenIdaris" return-object :items="idaris" item-text="ad"
              item-value="id" label="PBS İdari Birimler (Çoklu Seçim)" multiple chips deletable-chips
               clearable outlined dense></v-select>
</div>
    </v-card-text>

    <v-alert v-if="sonucListesi && sonucListesi.length > 0" type="success" text border="left" class="mx-4 mb-4">
      <div class="font-weight-bold">Seçilen ID Listesi ({{ sonucListesi.length }} adet):</div>
      <!-- <div>{{ sonucListesi }}</div> -->
    </v-alert>
    <v-card-actions>
      <v-spacer></v-spacer>

      <v-btn color="primary" text @click="saveSelected">Seçilenleri Aktar</v-btn>
    </v-card-actions>
  </v-card>


</template>

<script>
import FilterUserService from '@/services/FilterUserService';
export default {
  name: 'AcademicFilter',
  data() {
    return {
      // Örnek Veri Seti
      birimTur: 'personel', // Varsayılan seçim
      tumVeri: [
        { "fak_kod": "15", "fakulte_ad": "TIP FAKÜLTESİ", "bolum_id": "91644", "bolum_ad": "TIP", "program_id": "91648", "program_ad": "TIP FAKÜLTESİ" },
        { "fak_kod": "15", "fakulte_ad": "TIP FAKÜLTESİ", "bolum_id": "99999", "bolum_ad": "CERRAHİ TIP BİLİMLERİ", "program_id": "11111", "program_ad": "GENEL CERRAHİ" },
        { "fak_kod": "20", "fakulte_ad": "MÜHENDİSLİK FAK.", "bolum_id": "88888", "bolum_ad": "BİLGİSAYAR MÜH.", "program_id": "22222", "program_ad": "YAZILIM MÜH." },
        { "fak_kod": "20", "fakulte_ad": "MÜHENDİSLİK FAK.", "bolum_id": "88888", "bolum_ad": "BİLGİSAYAR MÜH.", "program_id": "33333", "program_ad": "BİLGİSAYAR MÜH. (İÖ)" }
      ],

      hedefSeviye: 'fakulte', // Varsayılan seçim

      // Seçilen Değerler (Array veya null/string olabilir)
      secilenFakulte: [],
      secilenBolum: [],
      secilenProgram: [],
      secilenIdaris:[], 
      idaris:[]
    };
  },
  watch: {
    birimTur() {
      this.dataBind();
    },
  },
  created() {

    this.dataBind();
  },
  computed: {
    // --- LİSTELERİ OLUŞTURAN COMPUTED PROPERTY'LER ---

    distinctFakulteler() {
      return this.getDistinct(this.tumVeri, 'fak_kod');
    },

    distinctBolumler() {
      // Eğer tekli fakülte seçilmediyse bölüm listesi boş gelsin
      // Not: Vuetify select "clearable" ile temizlenince değer null olur.
      if (!this.secilenFakulte || Array.isArray(this.secilenFakulte)) return [];

      const filtered = this.tumVeri.filter(item => item.fak_kod === this.secilenFakulte.fak_kod);
      return this.getDistinct(filtered, 'bolum_id');
    },

    distinctProgramlar() {
      // Eğer tekli bölüm seçilmediyse program listesi boş gelsin
      if (!this.secilenBolum || Array.isArray(this.secilenBolum)) return [];

      const filtered = this.tumVeri.filter(item => item.bolum_id === this.secilenBolum.bolum_id);
      return this.getDistinct(filtered, 'program_id');
    },

    // --- SONUÇ ---
    sonucListesi() {
      // Sadece seçili hedef seviyenin Array değerini döndür

      if (this.hedefSeviye === 'fakulte' && Array.isArray(this.secilenFakulte)) {
        return this.secilenFakulte;
      }
      if (this.hedefSeviye === 'bolum' && Array.isArray(this.secilenBolum)) {
        return this.secilenBolum;
      }
      if (this.hedefSeviye === 'program' && Array.isArray(this.secilenProgram)) {
        return this.secilenProgram;
      }
      return [];
    }
  },
  methods: {
    saveSelected() {
      let value = this.getValue();
      console.log("Seçilen unvan:", value);
      // Örneğin parent component'e emit edebilirsiniz
      this.$emit("selectedChange", value);
    },
    getValue() {
      let value = [];
if (this.birimTur==="personelidari") {
  value = this.secilenIdaris.map(m=>m.ad);
}  
else
{
     if (this.hedefSeviye === 'fakulte' && Array.isArray(this.secilenFakulte)) {
        //value= this.secilenFakulte.map(x=>{return {id:x.fak_kod,name:x.fakulte_ad}}); 
        value = this.secilenFakulte.map(x => x.fakulte_ad);
      }
      if (this.hedefSeviye === 'bolum' && Array.isArray(this.secilenBolum)) {
        //value= this.secilenBolum.map(x=>{return {id:x.bolum_id,name:x.bolum_ad}}); 
        value = this.secilenBolum.map(x => x.bolum_ad);
      }
      if (this.hedefSeviye === 'program' && Array.isArray(this.secilenProgram)) {
        // value= this.secilenProgram.map(x=>{return {id:x.program_id,name:x.program_ad}}); 
        value = this.secilenProgram.map(x => x.program_ad);
      }
}

   
      return value;
    },
    dataBind() {
      console.log("BirimTur:", this.birimTur);

      if (this.birimTur === 'ogrenci') {
        FilterUserService.ObsBirimListesi().then((result) => {
          //console.log("ObsBirimListesi:",result.data);
          this.tumVeri = result.data;
        }).catch((err) => {

        });
      } else if (this.birimTur === 'personel') {
        FilterUserService.PbsBirimListesi().then((result) => {
          //console.log("PbsBirimListesi:",result.data);
          this.tumVeri = result.data;
        }).catch((err) => {

        });
      }
      else {
        FilterUserService.listPBSIdariBirimler().then((result) => {
          this.idaris = result.data;
        }).catch((err) => {

        });
      }

    },
    // Yardımcı: Array içindeki objeleri belirtilen key'e göre unique yapar
    getDistinct(data, key) {
      const map = new Map();
      data.forEach(item => {
        if (!map.has(item[key])) {
          map.set(item[key], item);
        }
      });
      return [...map.values()];
    },

    // Hedef Seviye (Radio) değiştiğinde form yapısını ve verileri sıfırla
    resetForm() {
      // Eğer hedef "fakulte" ise -> fakulte multi (Array), diğerleri null
      // Eğer hedef "bolum" ise -> fakulte single (null), bolum multi (Array)
      // Eğer hedef "program" ise -> fakulte single, bolum single, program multi

      this.secilenFakulte = this.hedefSeviye === 'fakulte' ? [] : null;
      this.secilenBolum = this.hedefSeviye === 'bolum' ? [] : null;
      this.secilenProgram = []; // Program seçilirse hep multi
    },


    // Fakülte değiştiğinde
    fakulteChanged() {
      // Eğer hedefimiz zaten fakülte seçmekse (multi), alt tarafları tetiklemeye gerek yok
      if (this.hedefSeviye === 'fakulte') return;

      // Hedef bölüm veya program ise; üst değiştiği için altları temizle
      this.secilenBolum = this.hedefSeviye === 'bolum' ? [] : null;
      this.secilenProgram = [];
    },

    // Bölüm değiştiğinde
    bolumChanged() {
      // Eğer hedefimiz zaten bölüm seçmekse (multi), programı etkilemesin
      if (this.hedefSeviye === 'bolum') return;

      // Hedef program ise; bölüm değişince programı temizle
      this.secilenProgram = [];
    }
  },
  mounted() {
    this.resetForm();
  }
};
</script>